import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { ucwords } from '../../helper';
import * as actions from '../../actions';
import * as c from '../../constant';

function ValidateBusinessActivityModal({
  formData,
  setFormData,
  getNecessaryFieldsList,
  necessaryFieldsList,
  closeUpdateModal,
  handleValidateBusinessActivity,
  businessActivityInfo,
}) {
  useEffect(() => {
    getNecessaryFieldsList({
      business_line_id: _.get(
        businessActivityInfo,
        'attributes.business_line_id'
      ),
    });
  }, []);

  useEffect(() => {
    let keyValues = [];
    keyValues = Object.entries(
      _.get(businessActivityInfo, 'attributes.details') || ''
    ).map(([key, value]) => ({
      [key]: value.toString() || '',
    }));

    let finalObject = {};
    const badCallback = (a, i) => Object.assign(a, i);
    finalObject = keyValues.reduce(badCallback, {});

    setFormData({
      ...formData,
      ...finalObject,
      business_line_id: +_.get(
        businessActivityInfo,
        'attributes.business_line_id'
      ),
    });
  }, []);

  // select necessary field
  const handleOfficeTypeDropDownChange = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  const selectOptions = list => {
    const newList = [];

    list.map(data => {
      return newList.push({
        label: ucwords(_.get(data, 'multiplier'))
          .replace(/_/g, ' ')
          .replace(/^(.)|\s+(.)/g, x => x.toUpperCase()),
        value: data.multiplier,
      });
    });
    return newList;
  };

  const handleOnChange = key => e => {
    setFormData({
      ...formData,
      [key]: e.target.value,
    });
  };

  return (
    <div className="">
      <div className="row">
        <div className="px-3">
          <label className="text-primary font-weight-bold mr-2">Name:</label>
          <b>{_.get(businessActivityInfo, 'attributes.name')}</b>
        </div>
        <div className="col-12 form-group">
          {necessaryFieldsList.map(item => {
            return (
              <div>
                <div className="form-group">
                  {_.get(item, 'options') ? (
                    <div>
                      <label className="form-label">
                        {ucwords(_.get(item, 'multiplier').replace(/_/g, ' '))}{' '}
                      </label>
                      <Select
                        onChange={handleOfficeTypeDropDownChange(
                          _.get(item, 'multiplier')
                        )}
                        options={selectOptions(_.get(item, 'options'))}
                        value={
                          selectOptions(_.get(item, 'options')).find(
                            x =>
                              _.get(formData, _.get(item, 'multiplier')) ===
                              _.get(x, 'value')
                          ) || ''
                        }
                      />
                    </div>
                  ) : (
                    ''
                  )}
                </div>
                <div className="form-group">
                  {!_.get(item, 'options') ? (
                    <div>
                      <label className="form-label">
                        {ucwords(_.get(item, 'multiplier').replace(/_/g, ' '))}{' '}
                      </label>
                      <input
                        className="form-control"
                        name={_.get(item, 'label')}
                        id={_.get(item, 'label')}
                        onChange={handleOnChange(_.get(item, 'multiplier'))}
                        value={_.get(formData, _.get(item, 'multiplier'))}
                        required
                      />
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="d-flex justify-content-end pb-3">
        <button
          type="button"
          className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
          onClick={handleValidateBusinessActivity(formData)}
        >
          <span className="font-weight-bold">Validate</span>
        </button>
        <button
          type="button"
          onClick={() => closeUpdateModal()}
          className="mt-3 btn btn-dark mr-2"
        >
          <span className="font-weight-bold">Cancel</span>
        </button>
      </div>
    </div>
  );
}

ValidateBusinessActivityModal.propTypes = {
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Object).isRequired,
  getNecessaryFieldsList: PropTypes.instanceOf(Function).isRequired,
  necessaryFieldsList: PropTypes.instanceOf(Array).isRequired,
  closeUpdateModal: PropTypes.instanceOf(Function).isRequired,
  handleValidateBusinessActivity: PropTypes.instanceOf(Function).isRequired,
  businessActivityInfo: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  necessaryFieldsList: _.get(api, `${c.GET_NECESSARY_FIELD_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ValidateBusinessActivityModal);
